/**
 * M-OB-11 (§8.1): localStorage-Helfer für die bei der Registrierung gewählte
 * Kanzlei-Kennzeichnung, getragen über die Auth-Redirect-Kette (register →
 * verify-email → dashboard), bis `AuthContext` sie nach dem ersten
 * sellerData-Load nach `sellers/{uid}.accountType` persistiert.
 *
 * Bewusst getrennt von den Invite-Token-Helfern ({@link ./advisorInviteToken},
 * {@link ./clientInviteToken}) — eigener Key, eigener Wertebereich. `accountType`
 * ist ein reines UX-Signal (KEINE Autorisierungsquelle) und daher bewusst
 * client-schreibbar (`saveSellerData` strippt es NICHT; Firestore-Rules
 * verbieten es nicht).
 *
 * @module utils/pendingAccountType
 */

const PENDING_ACCOUNT_TYPE_KEY = 'faebill:pendingAccountType';

/** Der einzige aktuell unterstützte Marker-Wert. */
export const PENDING_ACCOUNT_TYPE_KANZLEI = 'kanzlei';

/**
 * Liest den Pending-Account-Type-Marker aus localStorage.
 *
 * @returns den Marker-String (`'kanzlei'`) oder `null`, wenn keiner gesetzt ist
 *   bzw. localStorage nicht verfügbar ist (fail-safe).
 */
export function getPendingAccountType(): string | null {
  try {
    return localStorage.getItem(PENDING_ACCOUNT_TYPE_KEY) || null;
  } catch {
    return null;
  }
}

/**
 * Setzt den Kanzlei-Marker, sodass er die Auth-Redirect-Kette überlebt. No-op,
 * wenn localStorage nicht verfügbar ist (Private-Browsing/Quota).
 */
export function setPendingAccountTypeKanzlei(): void {
  try {
    localStorage.setItem(PENDING_ACCOUNT_TYPE_KEY, PENDING_ACCOUNT_TYPE_KANZLEI);
  } catch {
    // Silently ignore (private-browsing quota / unavailable).
  }
}

/**
 * Entfernt den Pending-Account-Type-Marker. Muss NUR nach erfolgreicher
 * Persistenz (oder wenn `accountType` bereits gesetzt ist) aufgerufen werden —
 * NIEMALS im auth-null-Zustand (Boot), sonst wird der Marker vor dem Login
 * verschluckt (§8.1-Lehre).
 */
export function clearPendingAccountType(): void {
  try {
    localStorage.removeItem(PENDING_ACCOUNT_TYPE_KEY);
  } catch {
    // Silently ignore.
  }
}
